"use strict";
class SSHttpService {

    constructor($http, $window, $rootScope, SSUtilService, SSConfigService, SSStorageService) {
        const self = this;

        self.$http = $http;
        self.$window = $window;
        self.$rootScope = $rootScope;

        self.SSUtilService = SSUtilService;
        self.SSConfigService = SSConfigService;
        self.SSStorageService = SSStorageService;

        self.setBasicAuth();
    }

    setBasicAuth() {
        const self = this;

        let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        let isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);

        if ((isSafari || isIE) && APP_CONFIG.basicAuth) {
            let basicauth = self.SSStorageService.getFromSessionStorage('basicauth');

            if (!(basicauth && basicauth.username && basicauth.password)) {
                basicauth = {};
                basicauth.username = prompt('Authentication Required\nUsername:');
                basicauth.password = prompt('Authentication Required\nPassword:');

                if (!basicauth.username || !basicauth.password) {
                    self.$window.location.reload();
                }
            }

            self.$http.defaults.headers.common['Authorization'] = 'Basic ' + btoa(basicauth.username + ':' + basicauth.password);

            self.SSStorageService.saveToSessionStorage('basicauth', basicauth);
        }
    }

    /**
     * Get Request to get data from specified URL of Server
     * @param url
     * @param params
     * @param headers
     */
    getRequest(url, params = null, headers = null) {
        return this.sendRequest('GET', this.getServerURL(url), params, headers);
    }

    postRequest(url, params = null, headers = null) {
        return this.sendRequest('POST', this.getServerURL(url), params, headers);
    }

    putRequest(url, params = null, headers = null) {
        return this.sendRequest('PUT', this.getServerURL(url), params, headers);
    }

    /**
     * Delete Request to delete data from specified URL of Server
     * @param url
     * @param params
     */
    deleteRequest(url, params = null, headers = null) {
        return this.sendRequest('DELETE', this.getServerURL(url), params, headers);
    }

    /**
     * Get Request to get data from specified URL of API
     * @param url
     * @param params
     * @param headers
     */
    getAPIRequest(url, params = null, headers = null) {
        return this.sendRequest('GET', this.getApiURL(url), params, headers);
    }

    postAPIRequest(url, params = null, headers = null) {
        return this.sendRequest('POST', this.getApiURL(url), params, headers);
    }

    putAPIRequest(url, params=null, headers = null) {
        return this.sendRequest('PUT', this.getApiURL(url), params, headers);
    }

    deleteAPIRequest(url, params=null, headers=null) {
        return this.sendRequest('DELETE', this.getApiURL(url), params, headers);
    }

    sendRequest(method, url, params=null, headers=null) {
        let self = this;

        if (!params) {
            params = {}; // Null handling
        } else if (Array.isArray(params)) {
            params = {body: params}; // Convert body array data to dictionary
        }
        params.device_uuid = this.SSUtilService.localStorageUUID();

        // WEB-3591: no api_token is appended here any more. The request goes to
        // a same-origin proxy route which injects the token server-side from the
        // session (see ApiProxyService), so the token never reaches the browser.
        let urlArray = url.split('?');
        url = urlArray[0];

        if (urlArray.length > 1) {
            let urlParams = urlArray[1];

            $.each(urlParams.split('&'), function (i, p) {
                if (!p) {
                    // getApiURL() leaves a trailing '?' on the URL (see there),
                    // so the pair list can start with an empty entry.
                    return;
                }

                let pArray = p.split('=');
                params[pArray[0]] = pArray[1];
            });
        }

        if (self.SSConfigService
            && self.SSConfigService.serverConfig
            && self.SSConfigService.serverConfig.params_encoding_enabled
        ) {
            // Config as per env settings.
            params = encodeParams(params);
        }

        if (method=='POST') {
            // Params are sent as payload
            return this.$http.post(url, params, {withCredentials: true})
                .then(this.requestSuccess.bind(this), this.requestFailed.bind(this));
        } else if (method=='PUT') {
            // Params are sent as payload
            return this.$http.put(url, params, {withCredentials: true})
                .then(this.requestSuccess.bind(this), this.requestFailed.bind(this));
        } else {
            // Params are sent as querystring
            return this.$http({
                url: url,
                method: method,
                withCredentials: true,
                headers,
                params
            }).then(this.requestSuccess.bind(this), this.requestFailed.bind(this));
        }
    }

    requestSuccess(responseObj, obj) {
        return this.validateResponse(responseObj);
    }

    requestFailed(responseObj, obj) {
        return this.validateResponse(responseObj);
    }

    validateResponse(responseObj) {
        //this.$log.log(responseObj);

        // Add specific check for timeout
        if (responseObj && responseObj.status === 504) {
            return responseObj;
        }

        //check if success flag return in response, a compulsory object for SHowSuite valid response
        if (!_.has(responseObj, 'data.success')) {
            return this.makeErrorObject("Invalid data, no success status found", responseObj);
        }

        if (responseObj.data.success == false) {
            return this.makeErrorObject("Success status is false from server ", responseObj);
        }

        //return core object of $http so can read .success directly.
        return responseObj.data;

    }

    makeErrorObject(message, responseObj) {
        let errorObj = new Error(message);

        if (_.has(responseObj, 'data.code')) {
            errorObj.code = responseObj.data.code;
        }

        if (_.has(responseObj, 'data.sub_code')) {
            errorObj.sub_code = responseObj.data.sub_code;
        }

        if (_.has(responseObj, 'data.message')) {
            errorObj.message = responseObj.data.message;
        }

        if (_.has(responseObj, 'data.data')) {
            errorObj.data = responseObj.data.data;
        }

        this.SSUtilService.logError(errorObj);

        // Permission-denied responses may indicate that the user's permissions
        // were changed by an admin since the cached set was loaded at login.
        // Emit so SSUserService can silently refresh /sec/me. SSUserService
        // debounces the listener, so a burst of 403s only triggers one refresh.
        let httpStatus = responseObj && responseObj.status;
        if (this.$rootScope && (errorObj.code == 403 || httpStatus === 403)) {
            this.$rootScope.$emit('PermissionsMaybeChangedEvent');
        }

        return errorObj;
    }

    parseErrors(responseObj) {
        let errors = {};

        jQuery.each(responseObj.data, function (key) {
            try {
                errors[key] = responseObj.data[key][0];
            } catch (ex) {
            }
        });

        responseObj.data = errors;

        return responseObj.data;
    }

    /**
     * Same-origin API proxy settings, or null when the proxy is disabled.
     *
     * Injected by resources/views/layouts/includes/api_proxy_config.blade.php at
     * every point that declares the SHOWSUITE global, so it is present on every
     * page that runs Angular. Absent config is treated as ENABLED (the current
     * default) rather than disabled: a page that silently fell back to the
     * legacy transport would have no api_token to authenticate with — the token
     * no longer exists client-side — and every request on it would 401.
     *
     * @returns {{api: string, server: string, reports: string}|null} Route
     *          prefixes, without leading or trailing slashes.
     */
    getProxyPrefixes() {
        let config = (typeof SHOWSUITE !== 'undefined' && SHOWSUITE) ? SHOWSUITE.API_PROXY : null;

        if (config && config.enabled === false) {
            return null; // Emergency fallback, see config/api_proxy.php.
        }

        let prefixes = (config && config.prefixes) ? config.prefixes : {};

        return {
            api: prefixes.api || '_api',
            server: prefixes.server || '_srv',
            reports: prefixes.reports || '_reports'
        };
    }

    /**
     * Build a same-origin proxy URL for an upstream path.
     *
     * The returned URL ALWAYS contains a '?', even when the path carries no
     * query of its own. That is deliberate and load-bearing: the previous
     * implementation always appended '?api_token=...', so a number of call
     * sites concatenate their own params with a bare '&' onto whatever this
     * returns (e.g. `getApiURL('sec/eois/export') + '&property_id=' + id`, and
     * `url += '&only_aml_docs=true'` in payment_details.js). Dropping the
     * separator would turn those into a broken path segment rather than a query
     * param, silently and only on some screens. A leading empty pair ('?&a=1')
     * is valid and ignored by both PHP's parse_str and Angular's param parsing.
     *
     * @param {string} prefix Proxy route prefix.
     * @param {string} url    Upstream path, with or without a query string.
     * @returns {string}
     */
    buildProxyURL(prefix, url) {
        url = String(url === null || url === undefined ? '' : url).replace(/^\/+/, '');

        let proxied = '/' + prefix + '/' + url;

        return proxied.indexOf('?') === -1 ? proxied + '?' : proxied;
    }

    /**
     * URL for a versioned API endpoint (`{API_URL}/api/{version}/{url}`).
     *
     * WEB-3591: normally returns a same-origin proxy path so the browser never
     * needs — or holds — an api_token. Every consumer keeps working unchanged:
     * XHR, ng-file-upload POSTs, `window.open()` downloads and `<img src>` all
     * just use whatever this returns.
     *
     * @param {string} url Endpoint path, relative to the API version root.
     * @returns {string}
     */
    getApiURL(url) {
        const self = this;

        let prefixes = self.getProxyPrefixes();

        if (prefixes) {
            return self.buildProxyURL(prefixes.api, url);
        }

        // Legacy direct-to-upstream transport (API_PROXY_ENABLED=false only).
        if (SHOWSUITE
            && SHOWSUITE.data
            && SHOWSUITE.data.api_server
            && SHOWSUITE.data.api_server.api_url
            && SHOWSUITE.data.api_server.api_version
        ) {
            url = SHOWSUITE.data.api_server.api_url + '/api/' + SHOWSUITE.data.api_server.api_version + '/' + url;
        } else {
            url = self.$window.location.origin + '/api/1.0/' + url;
        }

        let apiToken = this.getUserApiToken();
        if (url.indexOf('?') === -1) {
            url += '?api_token=' + apiToken;
        } else {
            url += '&api_token=' + apiToken;
        }

        return url;
    }

    /**
     * Rewrite an ABSOLUTE upstream URL into the same-origin proxy path that
     * reaches the same endpoint.
     *
     * WEB-3591: needed where a stored URL, rather than a code path, decides the
     * endpoint — the Report History rows hold absolute upstream URLs that were
     * written by an earlier version of the app (and by getUpstreamApiURL) and
     * are re-opened later as download links. Any `api_token` in the stored
     * query is dropped: rows written before this change embedded one, and
     * re-opening those must not put it back in the address bar.
     *
     * A URL on an origin this app does not proxy (an S3 link, say) is returned
     * unchanged, so an unrecognised row still downloads rather than 404-ing.
     *
     * @param {string} url Absolute upstream URL.
     * @returns {string} Proxy path ending in a query separator, or $url as-is.
     */
    getProxyURLForUpstream(url) {
        const self = this;

        let prefixes = self.getProxyPrefixes();

        if (!prefixes || !url) {
            return url;
        }

        let apiBase = (SHOWSUITE && SHOWSUITE.data && SHOWSUITE.data.api_server && SHOWSUITE.data.api_server.api_url)
            ? SHOWSUITE.data.api_server.api_url.replace(/\/+$/, '')
            : '';
        let apiVersion = (SHOWSUITE && SHOWSUITE.data && SHOWSUITE.data.api_server && SHOWSUITE.data.api_server.api_version)
            ? SHOWSUITE.data.api_server.api_version
            : '';
        let reportBase = (typeof SHOWSUITE !== 'undefined' && SHOWSUITE && SHOWSUITE.LARAVEL_REPORT_SERVER_URL)
            ? SHOWSUITE.LARAVEL_REPORT_SERVER_URL.replace(/\/+$/, '')
            : '';

        // Longest base first: the versioned API prefix is a prefix of the
        // bare API base, so testing the bare one first would always win.
        let candidates = [];
        if (reportBase) {
            candidates.push({base: reportBase, prefix: prefixes.reports});
        }
        if (apiBase && apiVersion) {
            candidates.push({base: apiBase + '/api/' + apiVersion, prefix: prefixes.api});
        }
        if (apiBase) {
            candidates.push({base: apiBase, prefix: prefixes.server});
        }

        for (let i = 0; i < candidates.length; i++) {
            if (url.indexOf(candidates[i].base + '/') !== 0) {
                continue;
            }

            let rest = url.substring(candidates[i].base.length + 1);

            return self.buildProxyURL(candidates[i].prefix, self.stripApiTokenParam(rest));
        }

        return self.stripApiTokenParam(url);
    }

    /**
     * Remove any `api_token` pair from a URL's query string.
     *
     * @param {string} url
     * @returns {string}
     */
    stripApiTokenParam(url) {
        if (!url || url.indexOf('?') === -1) {
            return url;
        }

        let parts = url.split('?');
        let base = parts.shift();
        let query = parts.join('?');

        let kept = query.split('&').filter(function (pair) {
            return pair !== '' && pair.split('=')[0] !== 'api_token';
        });

        return kept.length ? base + '?' + kept.join('&') : base;
    }

    /**
     * ABSOLUTE upstream URL for a versioned API endpoint, with no credential.
     *
     * For the narrow case of handing the API a URL for it to fetch itself
     * later — the "Report History" / report-email flows POST `params.url` to
     * sec/developer/reports-history, and ReportHistoryService downloads it
     * server-to-server and stores the result on S3. A proxy path is useless
     * there (the API cannot resolve a Web2-relative path), so this keeps
     * returning an absolute upstream URL.
     *
     * No token is appended: the API appends the requesting user's own
     * `?api_token=` before fetching, so one was never needed from the client.
     *
     * @param {string} url Endpoint path, relative to the API version root.
     * @returns {string}
     */
    getUpstreamApiURL(url) {
        const self = this;

        let path = String(url === null || url === undefined ? '' : url).replace(/^\/+/, '');

        if (SHOWSUITE
            && SHOWSUITE.data
            && SHOWSUITE.data.api_server
            && SHOWSUITE.data.api_server.api_url
            && SHOWSUITE.data.api_server.api_version
        ) {
            return SHOWSUITE.data.api_server.api_url
                + '/api/' + SHOWSUITE.data.api_server.api_version + '/' + path;
        }

        return self.$window.location.origin + '/api/1.0/' + path;
    }

    /**
     * URL for a non-versioned route on the API server (`{API_URL}/{url}`).
     *
     * Unlike getApiURL() this never appended a token, so it keeps its original
     * contract and does NOT force a trailing '?'.
     *
     * @param {string} url Path on the API server.
     * @returns {string}
     */
    getServerURL(url) {
        const self = this;

        let prefixes = self.getProxyPrefixes();

        if (prefixes) {
            let proxied = String(url === null || url === undefined ? '' : url).replace(/^\/+/, '');

            return '/' + prefixes.server + '/' + proxied;
        }

        if (SHOWSUITE && SHOWSUITE.data && SHOWSUITE.data.api_server && SHOWSUITE.data.api_server.api_url && SHOWSUITE.data.api_server.api_version) {
            return SHOWSUITE.data.api_server.api_url + '/' + url;
        } else {
            return self.$window.location.origin + url;
        }
    }

    /**
     * URL for a report on the Laravel Reports server
     * (`{LARAVEL_REPORT_SERVER_URL}/{url}`).
     *
     * WEB-3591: the ~12 report download buttons used to hand-build
     * `LARAVEL_REPORT_SERVER_URL + path + '?api_token=' + token` and open it in
     * a new tab, putting the token in the address bar, the browser history and
     * the Reports server's access log. They now go through the proxy instead.
     *
     * Like getApiURL(), the result always ends in a query separator, because
     * every one of those call sites appends its own params with a bare '&'.
     *
     * @param {string} url Path on the Reports server, e.g. 'api/reports/x'.
     * @returns {string}
     */
    getReportURL(url) {
        const self = this;

        let prefixes = self.getProxyPrefixes();

        if (prefixes) {
            return self.buildProxyURL(prefixes.reports, url);
        }

        // Legacy direct-to-upstream transport (API_PROXY_ENABLED=false only).
        let base = (typeof SHOWSUITE !== 'undefined' && SHOWSUITE && SHOWSUITE.LARAVEL_REPORT_SERVER_URL)
            ? SHOWSUITE.LARAVEL_REPORT_SERVER_URL
            : '';
        let path = String(url === null || url === undefined ? '' : url).replace(/^\/+/, '');
        let legacy = base + '/' + path;

        legacy += (legacy.indexOf('?') === -1 ? '?' : '&') + 'api_token=' + this.getUserApiToken();

        return legacy;
    }

    getSGVerifyURL(url) {
        const self = this;

        return SHOWSUITE.SGVERIFY_API_URL + '/' + url;
    }

    getSGVerifyRequest(url, params = null, headers = null) {
        let vUrl = this.getSGVerifyURL(url);

        if (!params) params = {};
        // params.device_uuid = this.SSUtilService.localStorageUUID();

        let request = {
            url: vUrl,
            method: "GET",
            withCredentials: false,
            headers,
            params
        };

        return this.$http(request)
            .then(function successCallback(response) {
                return response;
            }, function errorCallback(response) {
                return response;
            });
    }

    /**
     * The api_token held client-side, for the legacy direct-to-upstream
     * transport only (API_PROXY_ENABLED=false).
     *
     * WEB-3591: with the proxy enabled — the default — nothing client-side ever
     * holds a token, so this returns null and no caller needs it. It is kept
     * solely so the emergency fallback path still works; remove it together
     * with that path once the proxy is proven in production.
     *
     * @returns {string|null}
     */
    getUserApiToken() {
        if (this.getProxyPrefixes()) {
            return null;
        }

        let user = this.SSUtilService.getFromLocalStorage('user');
        return user ? user.api_token : null;
    }

    //-------------------------------------------

    /**
     * Look up a Singapore postal code and return its first address match.
     *
     * WEB-4652: OneMap's Search API now requires a token that cannot ship to the
     * browser, so the lookup goes through the Showsuite API
     * (`GET sec/onemap/search`, WEB-4650), which calls OneMap with a server-held
     * token. The API wraps OneMap's body in `data`, so results are read from
     * `response.data.results`; the result fields (BLK_NO, ROAD_NAME, BUILDING,
     * ADDRESS, POSTAL, plus LATITUDE/LONGITUDE/X/Y with geometry) are OneMap's own.
     *
     * @param {string}   postcode   6-digit postal code.
     * @param {Function} callback   `callback(result, errorMessage)`:
     *                              - match found       → (firstResult, null)
     *                              - no match / 412030 → (null, null), so callers keep
     *                                showing their own "Invalid postcode" message
     *                              - lookup failed     → (null, ADDRESS_LOOKUP_UNAVAILABLE_MESSAGE)
     * @param {boolean}  returnGeom Also return coordinates (default true, as before).
     * @returns {Promise}
     *
     * @remarks A 503/412031 (OneMap down) and any other failure — rate limit,
     * timeout, expired session — all mean "we could not look it up", not "this
     * postcode does not exist", so they get the manual-entry message and callers
     * must leave the address fields editable.
     */
    getAddressFromPostcode(postcode, callback, returnGeom = true) {
        return this.getAPIRequest('sec/onemap/search', {
            searchVal: postcode,
            returnGeom: returnGeom ? 'Y' : 'N',
            getAddrDetails: 'Y',
            pageNum: 1
        }).then(function (response) {
            callback.apply(null, SSHttpService.parseAddressLookupResponse(response));
        });
    }

    /**
     * Map a `sec/onemap/search` reply (as returned by sendRequest) onto the
     * `[result, errorMessage]` pair getAddressFromPostcode() hands its callback.
     *
     * @param {Object|Error} response validateResponse() output.
     * @returns {Array} `[firstResult|null, errorMessage|null]`
     */
    static parseAddressLookupResponse(response) {
        if (response instanceof Error) {
            // 412030 is the API rejecting the postcode itself.
            return [null, response.sub_code == 412030 ? null : SSHttpService.ADDRESS_LOOKUP_UNAVAILABLE_MESSAGE];
        }

        if (!response || response.success !== true) {
            // e.g. a 504, which validateResponse() passes through raw.
            return [null, SSHttpService.ADDRESS_LOOKUP_UNAVAILABLE_MESSAGE];
        }

        let results = response.data && response.data.results;
        return [results && results.length > 0 ? results[0] : null, null];
    }
    //-------------------------------------------

}

/**
 * WEB-4652: shown when the postal-code lookup could not be done (OneMap down,
 * 503 / sub_code 412031), so the user types the address in instead.
 * @type {string}
 */
SSHttpService.ADDRESS_LOOKUP_UNAVAILABLE_MESSAGE = 'Address lookup is unavailable, please enter the address manually.';

SSHttpService.$inject = ['$http', '$window', '$rootScope', 'SSUtilService', 'SSConfigService', 'SSStorageService'];
app.service('SSHttpService', SSHttpService);